/* Anyaparfum */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-burger]');
    if (!b) return;
    var nav = document.getElementById('site-nav');
    if (!nav) return;
    b.setAttribute('aria-expanded', nav.classList.toggle('is-open') ? 'true' : 'false');
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    var gal = t.closest('[data-gallery]');
    var stage = gal.querySelector('[data-stage]');
    stage.src = t.dataset.full;
    stage.alt = t.dataset.alt || '';
    gal.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
    t.setAttribute('aria-current', 'true');
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = b.dataset.qty === 'up' ? v + 1 : Math.max(1, v - 1);
  });

  var form = document.querySelector('[data-buy-form]');
  if (form) {
    form.addEventListener('change', function (e) {
      var r = e.target.closest('input[name="id"]');
      if (!r) return;
      form.querySelectorAll('.pack').forEach(function (p) { p.classList.remove('is-on'); });
      r.closest('.pack').classList.add('is-on');
      var d = r.dataset;
      var now = document.querySelector('[data-price-now]');
      var was = document.querySelector('[data-price-was]');
      var save = document.querySelector('[data-price-save]');
      var btn = form.querySelector('[data-add]');
      if (now) now.textContent = d.price;
      if (was) { was.textContent = d.compare || ''; was.style.display = d.compare ? '' : 'none'; }
      if (save) { save.textContent = d.save || ''; save.style.display = d.save ? '' : 'none'; }
      document.querySelectorAll('[data-sticky-price]').forEach(function (x) { x.textContent = d.price; });
      if (btn) {
        var avail = d.available === 'true';
        btn.disabled = !avail;
        btn.querySelector('span').textContent = avail ? btn.dataset.labelAdd : 'Épuisé';
      }
    });
  }

  /* expédition : coupure à l'heure de Paris + date de réception estimée */
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function parisNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function addWorkingDays(d, n) {
    var r = new Date(d);
    while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
    return r;
  }
  function tick() {
    var nodes = document.querySelectorAll('[data-cutoff]');
    if (!nodes.length) return;
    var now = parisNow();
    var target = new Date(now); target.setHours(15, 0, 0, 0);
    var beforeCut = now < target;
    if (!beforeCut) target.setDate(target.getDate() + 1);
    var diff = Math.max(0, target - now);
    var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
    var weekend = now.getDay() === 6 || now.getDay() === 0;
    var eta = addWorkingDays(now, beforeCut && !weekend ? 2 : 3);
    var etaTxt = JOURS[eta.getDay()] + ' ' + eta.getDate() + ' ' + MOIS[eta.getMonth()];
    nodes.forEach(function (n) {
      var clock = n.querySelector('[data-clock]');
      var lead = n.querySelector('[data-lead]');
      var when = n.querySelector('[data-eta]');
      if (clock) clock.textContent = pad(h) + ' h ' + pad(m) + ' min ' + pad(s) + ' s';
      if (lead) lead.textContent = weekend ? 'Départ de l\u2019entrep\u00f4t lundi matin \u2014 prochaine coupure dans'
        : (beforeCut ? 'Exp\u00e9di\u00e9 aujourd\u2019hui si vous commandez dans les' : 'Exp\u00e9di\u00e9 demain matin \u2014 prochaine coupure dans');
      if (when) when.textContent = etaTxt;
    });
  }
  if (document.querySelector('[data-cutoff]')) { tick(); setInterval(tick, 1000); }

  var sticky = document.querySelector('[data-sticky-buy]');
  var anchor = document.querySelector('[data-add]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-in', !en[0].isIntersecting); },
      { rootMargin: '-88px 0px 0px 0px' }).observe(anchor);
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
      document.querySelector('[data-add]').click();
    });
  }

  var vids = document.querySelectorAll('[data-ugc] video');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.isIntersecting ? en.target.play().catch(function () {}) : en.target.pause(); });
    }, { threshold: 0.55 });
    vids.forEach(function (v) { io.observe(v); });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ugc] .ugc__card');
    if (!c) return;
    var v = c.querySelector('video'); if (!v) return;
    v.muted = !v.muted;
    var s = c.querySelector('.ugc__sound'); if (s) s.textContent = v.muted ? '🔇' : '🔊';
    if (v.paused) v.play().catch(function () {});
  });
})();
